import React, {
  useState, useContext, useEffect, useMemo
} from 'react';
import {
  Outlet, useParams, useNavigate, useLocation,
  useOutletContext,
} from 'react-router-dom';
import { useSwarm } from '@lbs/swarm-client';

import { getNextRacingsList, getRegiongsList } from '@racings/api/requests';
import { SportTypesIds, SportTypesUrlIds } from '@racings/constants/enums/sportTypes';

import './styles.scss';
import { GetArrayGame, GetArrayRegion } from '@common/helpers/util/swarmTreeDestructuring';
import { asyncWrapper } from '@common/hocs/asyncWrapper';
import { RacingsContext } from '@racings/store/context';
import { useTranslation } from '@common/hooks/translation';

import { RegionList } from '../regionList';
import { ComingSoonRacings } from '../comingSoonRacings';
import { switchButtons } from './constant';

export const RacingsLayout = asyncWrapper(({ searchText,  setSearchtext = () => {}, routePrefix = '' }) => {
  const {
    sportType, compId,
  } = useParams();
  const { pathname } = useLocation();
  const path = pathname.split('/')[4];
  const [activeTab, setActiveTab] = useState(path);
  const _contextValue = useOutletContext();  
  const searchState = useMemo(() => ([searchText, setSearchtext]), [searchText, setSearchtext]);
  const contextValue = searchText || searchText === '' ? searchState : _contextValue;
  const t = useTranslation();
  const [racingState, setRacingsState] = useContext(RacingsContext);
  const navigate = useNavigate();
  const activeSportId = SportTypesUrlIds[sportType] || SportTypesIds.HORSE;

  const data = GetArrayRegion(useSwarm(getRegiongsList(activeSportId)).region);

  const { isYesterday, resultData } = racingState;

  const regionList = data?.map((item) => ({
    RegionName: item.name,
    RegionAlias: item.alias,
    Id: item.id,
    gameCount: item.game,
  }));

  useEffect(() => {
    setRacingsState((old) => ({
      ...old,
      resultData: { yesterday: null, today: null },
    }));
  }, [activeSportId, setRacingsState]);

  useEffect(() => {
    if (!path) {
      setActiveTab('upComing');
      navigate(`${routePrefix}/racings/${sportType}/upComing`);
    } else {
      setActiveTab(path);
    }
  }, [path]);

  useEffect(() => {
    if (!sportType) {
      navigate(`${routePrefix}/racings/horse-racing/upComing`);
    }
    if (sportType) {
      navigate(`${routePrefix}/racings/${sportType}/upComing`);
    }
  }, [sportType]);

  if (!data.length) {
    return <div className="racings-app-no-data">{t('No data')}</div>;
  }

  return (
    <div className="racings-app">
      <div className="racings-app-wrapper">
        <div className="racings-content-wrapper">
          <RegionList
            routePrefix={routePrefix}
            activeTab={activeTab}
            list={activeTab === 'upComing' ? regionList : (resultData[isYesterday ? 'yesterday' : 'today']?.details || [])}
          />
          <div className="racings-main-content">
            <div className="race-result-switch-wrapper">
              <div className="swtich-wrapper">
                {switchButtons.map((item) => (
                  <div
                    className={`${activeTab === item.type ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab(item.type);
                      navigate(`${routePrefix}/racings/${sportType}/${item.type}/`);
                    }}
                    key={item.type}
                  >
                    {t(item.name)}
                  </div>
                ))}
              </div>
            </div>
            {activeTab !== 'result' && !compId && !!regionList.length && (
              <ComingSoonRacings />
            )}
            <Outlet context={contextValue} />
          </div>
        </div>
      </div>
    </div>
  );
});
